// One native Shopify form; mobile disclosure is progressive enhancement.
class CalvielleNotes extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const button = this.querySelector('.calvielle-notes__toggle');
    const panel = this.querySelector('.calvielle-footer__newsletter-grid');
    if (!button || !panel) return;
    const mobile = matchMedia('(max-width: 749px)');
    let expanded = Boolean(panel.querySelector('.calvielle-footer__form-message'));
    const render = () => {
      button.hidden = !mobile.matches;
      panel.hidden = mobile.matches && !expanded;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      button.querySelector('.calvielle-notes__symbol').textContent = panel.hidden ? '+' : '−';
    };
    button.addEventListener('click', () => { expanded = !expanded; render(); }, { signal });
    mobile.addEventListener('change', render, { signal });
    // Keep server validation/success messages visible after form navigation.
    panel.addEventListener('invalid', () => { expanded = true; render(); }, { capture: true, signal });
    this.setAttribute('data-enhanced', '');
    render();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('calvielle-notes')) customElements.define('calvielle-notes', CalvielleNotes);
